import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { WatchListService } from '../../services/watch-list.service';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { ShoppingCart } from '../../models/shopping-cart.model';
import { CommonService } from '../../services/common.service';
import { WatchListItemNew } from '../../models/watch-list.model';
import { ProductDetail } from '../../models/product-detail.model';
import { Sort } from '@angular/material/sort';
import { getStockOnHand } from '../../shared/tools.collections';


// ngrx
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { getWatchListStateLoaded, getWatchListStateProducts } from '../../reducers/watchlist.reducer';
import { LoadWatchList, DeleteWatchListItem } from '../../actions/watchlist.actions';
import { getShoppingCartLoaded, getSelectedShoppingCart, getShoppintCartItemLoading } from '../../reducers/shoppingcart.reducer';
import { InsertShoppingCartItem } from '../../actions/shoppingcart.actions';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { AuthService } from '../../services/auth.service';
import { take } from 'rxjs/operators';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-watch-list',
  templateUrl: './watch-list.component.html',
  styleUrls: ['./watch-list.component.css']
})

export class WatchListComponent implements OnInit {

  title = 'Watch List';
  products: WatchListItemNew[];
  productsFilter: WatchListItemNew[];
  sortedData: WatchListItemNew[];
  shoppingCarts: ShoppingCart[];
  cartId: number;
  loadContent: boolean;
  productDetailArray: ProductDetail[] = [];
  searchFilter: string;
  currentUserModel: CurrentUserModel;
  @ViewChild('entry', { read: ViewContainerRef })
  entry: ViewContainerRef;

  constructor(
    private router: Router,
    private watchListService: WatchListService,
    private shoppingCartService: ShoppingCartService,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private authService: AuthService,
    private store: Store<AppState>
  ) { }

  ngOnInit() {
    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;
    },
      (error: any) => {
        console.info(error);
      });
    this.loadContent = false;

    this.store.select(getWatchListStateLoaded).pipe(take(1))
      .subscribe(hasLoaded => {
        if (!hasLoaded) {
          this.store.dispatch(new LoadWatchList());
        }
        this.store.select(getWatchListStateProducts).subscribe(products => {
          this.products = products;
          this.productsFilter = this.products;
          this.sortedData = this.productsFilter;
          this.loadContent = true;
        }
        );

      });

    // this.watchListService.getWatchList().subscribe(ps => {
    //   if (ps) {
    //     this.products = ps;
    //     this.productsFilter = this.products;
    //     this.sortedData = this.productsFilter.slice();
    //   }
    //   this.loadContent = true;
    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.loadContent = true;
    //   });

    this.store.select(getShoppingCartLoaded).subscribe((isLoaded) => {
      if (isLoaded) {
        this.store.select(getSelectedShoppingCart).subscribe(cart => {
            if (cart) {
              this.cartId = cart.cartId;
            }
        });
        this.store.select(getShoppintCartItemLoading).subscribe(loading => {
          this.loadContent = !loading;
        });
      }
    });

    // this.shoppingCartService.currentCartId.subscribe(cn => {
    //   this.cartId = cn;
    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.loadContent = true;
    //   });
  }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }

  sortData(sort: Sort) {
    const data = this.productsFilter.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'description': return compare(a.out_description, b.out_description, isAsc);
        case 'soh': return compare(this.sohLoad(a), +this.sohLoad(b), isAsc);
        case 'price': return compare(a.out_current_price, +b.out_current_price, isAsc);
        default: return 0;
      }
    });
  }

  sohLoad(watchItem: WatchListItemNew): string {
    return getStockOnHand(watchItem.out_avail_stock_qty, watchItem.out_max_order_qty ? watchItem.out_max_order_qty : '0', '', watchItem.out_freight_policy, '');
  }

  filterCartItems(): void {
    if (this.searchFilter) {
      const searchFiled = this.searchFilter.toLowerCase();
      this.productsFilter = this.products.filter(watchItem => watchItem.out_description.toLowerCase().includes(searchFiled)
        || watchItem.out_avail_stock_qty.toString().includes(searchFiled) || watchItem.out_stock_code.toLowerCase().includes(searchFiled)
        || watchItem.out_brand.toLowerCase().includes(searchFiled) || watchItem.out_current_price.toString().includes(searchFiled) || watchItem.out_rrp_excl_tax.toString().includes(searchFiled));
      this.sortedData = this.productsFilter.slice();
    } else {
      this.productsFilter = this.products;
      this.sortedData = this.productsFilter.slice();
    }
  }

  close() {
    $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    this.router.navigateByUrl('/myCarts');
  }

  addToCart(event, product: WatchListItemNew): void {
    event.stopPropagation();
    event.preventDefault();
    this.store.dispatch(new InsertShoppingCartItem({ stockCode: encodeURIComponent(product.out_stock_code), cartId: this.cartId, Qty: '1' }));
    // this.loadContent = false;
    // this.shoppingCartService.addItemToShoppingCart(encodeURIComponent(product.out_stock_code), this.cartId, "1").subscribe((data: ApiResponse) => {
    //   if (data.status) {
    //     this.shoppingCartService.monitorStatusChange(2);
    //     this.commonService.implementToast(`Successfully add ${product.out_stock_code} to cart`, "Success");
    //     this.loadContent = true;
    //   } else {
    //     this.commonService.implementToast(`Fail to add ${product.out_stock_code} to cart`, "Error");
    //     this.loadContent = true;
    //   }
    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.loadContent = true;
    //   });

  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  RemoveWatchItem(event, stockCode: string): void {
    event.stopPropagation();
    event.preventDefault();
    this.store.dispatch(new DeleteWatchListItem(stockCode));
  }
  // RemoveWatchItem(event, stockCode: string): void {
  //   event.stopPropagation();
  //   event.preventDefault();
  //   this.loadContent = false;
  //   this.watchListService.deleteWatchList(encodeURIComponent(stockCode)).subscribe((data: ApiResponse) => {
  //     if (data.status) {
  //       this.watchListService.monitorWatchListItemChange(stockCode + "delete");
  //       this.watchListService.getWatchList().subscribe(ps => {
  //         this.commonService.implementToast(data.responseMessage, "Success");
  //         if (ps) {
  //           this.products = ps;
  //           this.productsFilter = this.products;
  //           this.sortedData = this.productsFilter.slice();
  //         } else {
  //           this.products = [];
  //           this.productsFilter = this.products;
  //           this.sortedData = [];
  //         }
  //         this.loadContent = true;
  //       },
  //         (error: any) => {
  //           console.error(error);
  //           this.loadContent = true;
  //         });
  //     } else {
  //       this.commonService.implementToast(data.responseMessage, "Error");
  //     }
  //   },
  //     (error: any) => {
  //       console.error(error);
  //       this.loadContent = true;
  //     });
  // }

  checkProductDetail(stockCode: string): void {
    stockCode = encodeURIComponent(stockCode);
    this.router.navigate([`product/${stockCode}`], { relativeTo: this.activatedRoute });
  }

  notifyWatchItem(event, product: WatchListItemNew): void {
    event.stopPropagation();
    event.preventDefault();
    this.router.navigate([`notification/${product.out_stock_code}`], { relativeTo: this.activatedRoute });
  }
}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
